export const EMPTY_MESSAGE_TEXT_ERROR = 'Должен быть заполнен текст сообщения';
export const EMPTY_MESSAGE_TOAST_ERROR =
  'При наличии прикрепленных файлов должен быть заполнен текст сообщения';
